__webpack_require__.p = "/minipedia/";